export interface VKLaunchParams {
  vk_user_id?: string;
  vk_peer_id?: string;
  vk_app_id?: string;
  vk_platform?: string;
  vk_access_token_settings?: string;
  sign?: string;
  [key: string]: string | undefined;
}

export interface VKGetLaunchParamsResult {
  vk_user_id?: number;
  vk_peer_id?: number;
  vk_app_id?: number;
  vk_platform?: string;
  vk_language?: string;
  vk_ref?: string;
  vk_access_token_settings?: string;
  sign?: string;
  [key: string]: string | number | undefined;
}

export function parseVKLaunchParamsFromUrl(): { rawQuery: string; params: Record<string, string> } {
  if (typeof window === 'undefined') {
    return { rawQuery: '', params: {} };
  }
  const rawQuery = (window.location.search || window.location.hash || '').replace(/^[#?]/, '').replace(/^\/+/, '');
  const urlParams = new URLSearchParams(rawQuery);
  const params: Record<string, string> = {};
  for (const [key, value] of urlParams) {
    params[key] = value;
  }
  return { rawQuery, params };
}

/**
 * После VKWebAppGetLaunchParams: vk_platform часто только здесь, не в URL iframe.
 * Мержим в getVKLaunchParams() поверх query — иначе detectSurface() даёт ложный vk_native и режет оплату на desktop_web.
 */
let launchParamsFromBridge: Record<string, string> = {};

export const VK_LAUNCH_PARAMS_UPDATED_EVENT = 'minibook:vk-launch-params-updated';

export function applyVKLaunchParamsFromBridge(lp: Record<string, unknown> | null | undefined): void {
  launchParamsFromBridge = {};
  if (!lp || typeof lp !== 'object') return;
  for (const [k, v] of Object.entries(lp)) {
    if (k === 'rawQuery' || v == null) continue;
    launchParamsFromBridge[k] = typeof v === 'object' ? JSON.stringify(v) : String(v);
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(VK_LAUNCH_PARAMS_UPDATED_EVENT));
  }
}

export function getVKLaunchParams(): { rawQuery: string; params: Record<string, string> } {
  const fromUrl = parseVKLaunchParamsFromUrl();
  if (Object.keys(launchParamsFromBridge).length === 0) return fromUrl;
  return {
    rawQuery: fromUrl.rawQuery,
    params: { ...fromUrl.params, ...launchParamsFromBridge },
  };
}

/** Только vk_peer_id — появляется после явного разрешения сообщений от группы. */
export function getVKPeerIdForMessages(params: VKGetLaunchParamsResult | VKLaunchParams): string | null {
  return params.vk_peer_id != null ? String(params.vk_peer_id) : null;
}

export function getVKUserId(params: VKGetLaunchParamsResult | VKLaunchParams): string | null {
  return params.vk_user_id ? String(params.vk_user_id) : null;
}

